import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import $ from "jquery";
import './home.css';
import { Link } from 'react-router-dom';

import { MoonLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';
import { getTrendingMovies } from '../../Redux/tmSlice';
import { getTrendingSeries } from '../../Redux/tsSlice';




function Home() {

 

  const {data} = useSelector(state => state.trendingSeries)
  
  const movie = useSelector(state => state.trendingMovies)



  const dispatch = useDispatch()

  useEffect(() => {
    
    dispatch(getTrendingMovies());
    dispatch(getTrendingSeries())

  }, [])
  

  return <>
    {movie && data ? <>
    <div className="container">
      <div className="row">
        <div className="col-md-4 align-self-center">
          <div>
            <div className='upper'></div>
            <h5>Trending Movies to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
        </div>
        {movie.data.results.map((movie, idx) => 
        <div key={idx} className='col-md-2 my-2'>
          <Link to={`/moviedetails/${movie.id}`}>
          <div className="movie position-relative imghov">
            <img className='rounded-3 w-100 ' src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path} alt="moviepic" />
            <h6 className='rating p-2 rounded-circle'>{(movie.vote_average).toFixed(1)}</h6>
            <h6 className='mt-2'>{movie.title}</h6>
          </div>
          </Link>
        </div>
        )}
      </div>
      <div className="row align-items-center">
        <div className="col-md-4">
          <div>
            <div className='upper'></div>
            <h5>Trending Series to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
        </div>
        {data.data.results.map((series, idx) => <div key={idx} className='col-md-2 my-2'>
          <Link to={`/seriesdetails/${series.id}`}>
          <div className="series imghov position-relative">
            <img className='w-100 rounded-3' src={"https://image.tmdb.org/t/p/w500/" + series.poster_path} alt="seriespic" />
            <h6 className='rating p-2 rounded-circle'>{(series.vote_average).toFixed(1)}</h6>
            <h6 className='mt-3'>{series.name}</h6>
          </div>
          </Link>
        </div>)}
      </div>
    </div>
    </>: <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}







  </>
}

export default Home;


